import type { Config } from "@/api/models"

import { useConfigQuery } from "@/hooks/use-config-query"

import { DEFAULT_DOCUMENT_PREVIEW_SLOW_MS } from "../utils/citation-hover-mini-renderer"

function selectDocumentPreviewSlowMs(config: Config): number {
  const raw = config.documentPreviewSlowMs
  if (typeof raw === "number" && Number.isFinite(raw) && raw >= 0) {
    return raw
  }
  return DEFAULT_DOCUMENT_PREVIEW_SLOW_MS
}

/** Server `documentPreviewSlowMs` (docx/xlsx slow threshold, ms); falls back while config loads. */
export function useDocumentPreviewSlowMs(): number {
  const { data } = useConfigQuery({ select: selectDocumentPreviewSlowMs })
  return data ?? DEFAULT_DOCUMENT_PREVIEW_SLOW_MS
}
